/**
 * Features
 */
export var FeatureType;
(function (FeatureType) {
    FeatureType["Pro"] = "Pro";
    FeatureType["Con"] = "Con";
})(FeatureType || (FeatureType = {}));
//# sourceMappingURL=ProductComparison.types.js.map